/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class ProcessService {
    public static $inject = [
        '$http',
        '$q',
        'Api',
        'bsLoadingOverlayService',
        'toaster',
    ];
    public defs = {}
    public getPath

    constructor(
        private $http: angular.IHttpService,
        private $q: angular.IQService,
        private Api: Restangular.IService,
        private bsLoadingOverlayService: IBsLoadingService,
        private toaster: toaster.IToasterService,)
    {
        this.getPath = (type, state, path) => {
            return this.$q((resolve, reject) => {
                this.getDef(type).then((def) => {
                    var result = []
                    for (var i=0; i < path.length; i++) {
                        var state_def = def.states[state]
                        if (state_def === undefined) { break }
                        var transition_def = state_def.transitions[path[i]]
                        if (transition_def === undefined) { break }
                        if (transition_def.title) {
                            result.push(transition_def.title)
                        } else {
                            var who = 'Anyone'
                            if (transition_def.who == 'creator') {
                                who = 'Initiator' }
                            if (transition_def.who == 'creator__superior') {
                                who = "Initiator's Superior" }
                            if (transition_def.who == 'clearance__audit') {
                                who = 'C-Level' }
                            if (transition_def.who == 'clearance__edit') {
                                who = 'HR' }
                            if (transition_def.who == 'clearance__admin') {
                                who = 'Admin' }
                            if (transition_def.who == 'data__employee') {
                                who = 'Subject' }
                            if (transition_def.who == 'data__employee__superior') {
                                who = "Subject's Superior" }
                            var transition_name = path[i].charAt(0).toUpperCase() + path[i].slice(1)
                            result.push(who + ': ' + transition_name)
                        }
                        state = transition_def.state
                    }
                    if (path.length == 0) { return 'Done' }
                    return resolve(result)
                }, reject)
            })
        }
    }

    public getProcessList(filters: any, page: number): Restangular.IPromise<any> {
        // return this.Api.one('processes').getList('', filters);
        var params: any = {
            filters: filters,
            page: page
        };
        const apiCall = this.Api.all('processes').customGET('', params);
        apiCall.catch((err) => {
            if (err.status !== 200) {
                this.bsLoadingOverlayService.stop({referenceId: 'requests_loader'});
                this.toaster.pop('error', 'Server Error', err.message);
            }
        })
        return apiCall;
    }

    public getDef(type): angular.IPromise<any> {
        if (this.defs[type] === undefined) {
            this.defs[type] = this.$q((resolve, reject) => {
                return this.$http.get('/static/schemas/'+type+'.def.json').then((response) => {
                    return resolve(response.data)
                }, reject)
            });
        }
        return this.defs[type]
    }

    public createProcess(process: any): any {
        return this.Api.restangularizeElement(undefined, process, 'processes').save();
    }

    public transition(id: string, transition: {transition: string, data: any}): any {
        return this.$http.post('/api/processes/'+id+'/transitions', transition)
    }

    public loadProcess(process_id: string): any {
        return this.Api.one('processes', process_id).get();
    }

    public saveComment(process_id: string, comment: string): Restangular.IPromise<any> {
        return this.Api.one('processes', process_id).one('comments').customPOST({ comment: comment })
    }

    public archiveProcess(process_id: string): Restangular.IPromise<any> {
        return this.Api.one('processes', process_id).one('archived').customPOST({ archived: true })
    }

    public unArchiveProcess(process_id: string): Restangular.IPromise<any> {
        return this.Api.one('processes', process_id).one('archived').customPOST({ archived: false})
    }

    public saveLeaveType(process_id: string, leave_type: string): Restangular.IPromise<any> {
        return this.Api.one('processes', process_id).one('leave_type').customPOST({ leave_type: leave_type})
    }

    public deleteProcess(process_id: string): any{
        return this.Api.one('processes').one(process_id).remove();
    }

    public getLeaveProcessesByUser(id: string, fn): void {
        this.Api.one('processes').get({
            type: 'leave',
            employee: id}
        ).then((response) => {
            (fn || angular.noop)(response);
        }, () => {
            (fn || angular.noop)(false);
        });
    }

    public updateViewedBy(id: any, array: any): any {
        return this.$http.post('/api/processes/'+id+'/update_viewedby', array)
    }

    public sendExpenseFileUpload(process_id: string, file: object): Restangular.IPromise<any> {
        return this.Api.one('processes', process_id).one('expensefileupload').customPOST({ file })
    }
}


angular.module('beneple.process')
    .service('Process', ProcessService);



// WEBPACK FOOTER //
// ./frontend/scripts/process/services/process.service.ts